module.exports = __webpack_public_path__ + "static/media/Layer-10.d6404791.png";